module.exports = __webpack_public_path__ + "img/PB-BRB.517ccd13.png";